import { figcaption, figcaptionSmall } from './Figcaption.css';
import type { FigcaptionElementProps } from './Figcaption.type';

export const FigcaptionElement = (props: FigcaptionElementProps) => {
  const { children } = props;

  return (
    <div className={figcaption}>
      <small className={figcaptionSmall}>{children}</small>
    </div>
  );
};
